
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightRoofOff as ObiLightRoofOffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-roof-off.js';
 
 
 

 
 export const ObiLightRoofOff = createComponent({
   react: React,
   tagName: 'obi-light-roof-off',
   elementClass: ObiLightRoofOffElement,
   events: {
     
   }
  });
 
 